import { useEffect } from 'react';
import useSWR from 'swr';
import { TokenIcons } from '../../../assets/icons';
import { config } from '../../../config/config';
import { LiquidityPoolType } from '../../../context/pool/poolTypes';
import {
    EnabledChains,
    // LiquidityPool,
    // TimeConversions,
    Tokens,
} from '../../../config/constants';
import { useWeb3React } from '@web3-react/core';
import {
    verifyChainConfig,
    // subgraphQuery
} from '../../../helpers';
import useDelayLoading from '../../useDelayLoading';
// import { formatUnits, parseUnits } from 'ethers/lib/utils';
import useTokenDetails from '../useTokenDetails';
// import { BigNumber } from 'ethers';

const liquidityPools: LiquidityPoolType[] = [
    {
        displayOrder: 0,
        poolId: config.addresses[config.defaultChain]!.liquidityPools.blueChip,
        // name: 'LP1',
        name: 'Bluechip Pool',
        lpToken: Tokens.BLUECHIP,
        docs: 'https://docs.unlimited.trade/protocol/or-liquidity-pools/pool-exposure/bluechip-pool',
        poolAssets: [TokenIcons.BTC, TokenIcons.ETH],
        apr: '10',
        openInterest: '0',
        feesEarned: '120',
        pnl: '1200',
        decimals: 24,
        currentPriceEstimate: '0',
        currentLpPriceEstimate: '0',
        isZeroPrice: true,
    },
    {
        displayOrder: 1,
        poolId: config.addresses[config.defaultChain]!.liquidityPools.altCoin,
        // name: 'LP2',
        name: 'Altcoin Pool',
        lpToken: Tokens.ALTCOIN,
        docs: 'https://docs.unlimited.trade/protocol/or-liquidity-pools/pool-exposure/altcoin-pool',
        poolAssets: [
            TokenIcons.ADA,
            TokenIcons.ARB,
            TokenIcons.BNB,
            TokenIcons.DOT,
            TokenIcons.MATIC,
            TokenIcons.XRP,
        ],
        apr: '6',
        openInterest: '0',
        feesEarned: '5000',
        pnl: '50000',
        decimals: 24,
        currentPriceEstimate: '0',
        currentLpPriceEstimate: '0',
        isZeroPrice: true,
    },
    {
        displayOrder: 2,
        poolId: config.addresses[config.defaultChain]!.liquidityPools.degen,
        // name: 'LP3',
        name: 'Degen Pool',
        lpToken: Tokens.DEGEN,
        docs: 'https://docs.unlimited.trade/protocol/or-liquidity-pools/pool-exposure/degen-pool',
        poolAssets: [TokenIcons.DOGE, TokenIcons.LINK, TokenIcons.UNI],
        apr: '5',
        openInterest: '0',
        feesEarned: '413',
        pnl: '4129',
        decimals: 24,
        currentPriceEstimate: '0',
        currentLpPriceEstimate: '0',
        isZeroPrice: true,
    },
];

let initialLoadUp = false;

const useLiquidityPools = () => {
    const { chainId } = useWeb3React();

    const delayComplete = useDelayLoading();

    const { decimals } = useTokenDetails(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    const { data, error } = useSWR(
        chainId && decimals ? ['lockedPools', chainId, decimals] : null,
        async (_, chainId, decimals) => {
            if (!verifyChainConfig(chainId)) return;

            // const query = `
            //     liquidityPools {
            //         totalWithdrawals
            //         totalValueLocked
            //         totalFeeAmount
            //         totalDeposits
            //         totalSupply
            //         symbol
            //         name
            //         totalPnL
            //         earlyWithdrawalFee
            //         defaultLockTime
            //         decimals
            //         currentLPPriceEstimate
            //         currentPriceEstimate
            //         assetDecimals
            //         id
            //         earlyWithdrawalTime
            //         historicalApr
            //         periodData(where: {dataPoint_contains: "DAILY"}, first: 7, orderBy: id, orderDirection: desc) {
            //             id
            //             feeAmount
            //         }
            //     }
            // `;

            // const data: {
            //     liquidityPools: LiquidityPool[];
            // } = await subgraphQuery(query, { chainId });

            // const newPools = liquidityPools.map((pool) => {
            //     const liquidityPool = data.liquidityPools.find(
            //         ({ id }) => id.toLowerCase() === pool.poolId.toLowerCase()
            //     );

            //     if (!liquidityPool) return pool;

            //     const weeklyFeeAmount = liquidityPool.periodData.reduce(
            //         (totalFee, { feeAmount }) => totalFee.add(feeAmount),
            //         BigNumber.from(0)
            //     );

            //     const apr = weeklyFeeAmount
            //         .mul(TimeConversions.WEEK_PER_YEAR)
            //         .mul(parseUnits('100', decimals))
            //         .div(liquidityPool.totalValueLocked);

            //     return {
            //         ...pool,
            //         poolId: liquidityPool.id,
            //         name: liquidityPool.name,
            //         openInterest: formatUnits(liquidityPool.totalValueLocked, decimals),
            //         pnl: formatUnits(liquidityPool.totalPnL, decimals),
            //         feesEarned: formatUnits(liquidityPool.totalFeeAmount, decimals),
            //         apr: formatUnits(apr, decimals),
            //         decimals: liquidityPool.decimals,
            //         currentPriceEstimate: formatUnits(
            //             liquidityPool.currentPriceEstimate,
            //             decimals
            //         ),
            //         currentLpPriceEstimate: formatUnits(
            //             liquidityPool.currentLPPriceEstimate,
            //             decimals
            //         ),
            //         isZeroPrice: parseUnits(
            //             liquidityPool.currentPriceEstimate.toString(),
            //             decimals
            //         ).isZero(),
            //     } as LiquidityPoolType;
            // });

            return liquidityPools;
        }
    );

    useEffect(() => {
        if (delayComplete) {
            initialLoadUp = true;
        }
    }, [delayComplete]);

    return {
        liquidityPools: data,
        isLoading: (!data && !error) || (!initialLoadUp && !delayComplete),
        error,
    };
};

export default useLiquidityPools;
